import axios from "axios"
import CryptoJS from "crypto-js"

const secKey = process.env.REACT_APP_SECRET_TOKEN

export const checkLogin = async (data) => {
    try {
        // Encrypt the username and password before sending
        let encryptedToken = CryptoJS.AES.encrypt(JSON.stringify(data), secKey).toString()
        
        let response = await axios({
            'method': 'post',
            'url': `https://api.wizhull.com/login`,
            data: {
                token: encryptedToken
            }
        })
        
        return {
            status: "success",
            message: response.data.message,
            token: response.data.token,
            username: response.data.username,
            role: response.data.role,
            eid: response.data.eid
        }
    } catch (err) {
        return {
            status: "failed",
            error: err.response?.data?.message || "Authentication failed"
        }
    }
}